import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';

export const useAndroidBackButton = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isListenerActive = true;

    const setupListener = async () => {
      await App.addListener('backButton', ({ canGoBack }) => {
        if (!isListenerActive) return;
        
        if (canGoBack) {
          navigate(-1);
        } else {
          App.exitApp();
        }
      });
    };

    setupListener();

    return () => {
      isListenerActive = false;
      App.removeAllListeners();
    };
  }, [navigate]);
};
